import * as React from "react";

const IconList: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="currentColor"><path fill="currentColor" d="M4.5,8.07187486 L5.06718743,8.40234375 L7.875,10.0406249 L7.875,1.125 L1.125,1.125 L1.125,10.0406249 L3.93281257,8.40234375 L4.5,8.07187486 Z M1.125,11.34375 L0,12 L0,10.6968749 L0,1.125 L0,0 L1.125,0 L7.875,0 L9,0 L9,1.125 L9,10.6968749 L9,12 L7.875,11.34375 L4.5,9.375 L1.125,11.34375 Z"  transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconList);
